export default {
  create({ userId, description, source }) {
    return {
      method: 'post',
      url: 'reports',
      data: {
        userId,
        description,
        source,
      },
    };
  },
};
